import { render, staticRenderFns } from "./CodeCopyDialog.vue?vue&type=template&id=4ef80c95&scoped=true&"
import script from "./CodeCopyDialog.vue?vue&type=script&lang=js&"
export * from "./CodeCopyDialog.vue?vue&type=script&lang=js&"
import style0 from "./CodeCopyDialog.vue?vue&type=style&index=0&id=4ef80c95&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef80c95",
  null
  
)

export default component.exports